module.exports = __webpack_public_path__ + "img/emoji_51.daccfd27.png";